import { render } from "./LastObjectSettingForm.vue?vue&type=template&id=50691d0d"
import script from "./LastObjectSettingForm.vue?vue&type=script&lang=js"
export * from "./LastObjectSettingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__